export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/Background": [~9,[2]],
		"/Background/About_the_Authors": [10,[2]],
		"/Background/About_the_Name": [11,[2]],
		"/Background/About_the_Site": [12,[2]],
		"/Background/Overview": [13,[2]],
		"/Background/Projectional_Editing": [14,[2]],
		"/Background/Testimonial": [15,[2]],
		"/Demo": [~16,[3]],
		"/Demo/Overview": [17,[3]],
		"/DocuProjectDemo": [18],
		"/Documentation": [~19,[4]],
		"/Documentation/CommandLine": [20,[4]],
		"/Documentation/Creating_the_Metamodel": [21,[4]],
		"/Documentation/Creating_the_Metamodel/Defining_Properties": [22,[4]],
		"/Documentation/Creating_the_Metamodel/Language_Structure": [23,[4]],
		"/Documentation/Customizations": [24,[4]],
		"/Documentation/Customizations/Editor_Customization": [25,[4]],
		"/Documentation/Customizations/External_Components": [26,[4]],
		"/Documentation/Customizations/Other_Customizations": [27,[4]],
		"/Documentation/Customizations/Scoper_Customization": [28,[4]],
		"/Documentation/Customizations/Typer_Customization": [29,[4]],
		"/Documentation/Customizations/Validator_Customization": [30,[4]],
		"/Documentation/Defining_an_Editor": [31,[4]],
		"/Documentation/Defining_an_Editor/Binary_Expressions": [32,[4]],
		"/Documentation/Defining_an_Editor/Boolean_Projections": [33,[4]],
		"/Documentation/Defining_an_Editor/Buttons": [34,[4]],
		"/Documentation/Defining_an_Editor/Ease_of_Editing": [35,[4]],
		"/Documentation/Defining_an_Editor/Fragments": [36,[4]],
		"/Documentation/Defining_an_Editor/Global_Projections": [37,[4]],
		"/Documentation/Defining_an_Editor/Indentation": [38,[4]],
		"/Documentation/Defining_an_Editor/Number_Projections": [39,[4]],
		"/Documentation/Defining_an_Editor/Projections_for_Limited_Concepts": [41,[4]],
		"/Documentation/Defining_an_Editor/Projections": [40,[4]],
		"/Documentation/Defining_an_Editor/Styling": [42,[4]],
		"/Documentation/Defining_an_Editor/The_Parser_Projection": [43,[4]],
		"/Documentation/Interpreter_Framework": [44,[4]],
		"/Documentation/Interpreter_Framework/The_Expressions_DSL": [45,[4]],
		"/Documentation/Interpreter_Framework/Understanding_the_Framework": [46,[4]],
		"/Documentation/Overview": [47,[4]],
		"/Documentation/Overview/Getting_Started": [48,[4]],
		"/Documentation/Overview/Running_Example": [49,[4]],
		"/Documentation/Scoping,_Typing,_and_Validating": [50,[4]],
		"/Documentation/Scoping,_Typing,_and_Validating/Scope_Provider": [51,[4]],
		"/Documentation/Scoping,_Typing,_and_Validating/Type_Provider": [52,[4]],
		"/Documentation/Scoping,_Typing,_and_Validating/Validator": [53,[4]],
		"/Documentation/Terminology": [54,[4]],
		"/Documentation/Under_the_Hood": [55,[4]],
		"/Documentation/Under_the_Hood/Core_Interfaces": [56,[4]],
		"/Documentation/Under_the_Hood/Editor_Framework": [57,[4]],
		"/Documentation/Under_the_Hood/Editor_Framework/External_Component_Box_Types": [58,[4]],
		"/Documentation/Under_the_Hood/Editor_Framework/Predefined_Boxes": [59,[4]],
		"/Documentation/Under_the_Hood/Editor_Interfaces": [60,[4]],
		"/Documentation/Under_the_Hood/FreTool_Interfaces": [61,[4]],
		"/Examples": [~62,[5]],
		"/Examples/Building_an_Interpreter": [63,[5]],
		"/Examples/Building_an_Interpreter/Basic_Evaluation_Functions": [64,[5]],
		"/Examples/Building_an_Interpreter/Finishing_the_Test": [65,[5]],
		"/Examples/Building_an_Interpreter/Using_the_Context": [66,[5]],
		"/Examples/External_Components": [67,[5]],
		"/Examples/External_Components/A_Sorted_Table": [68,[5]],
		"/Examples/External_Components/A_Wrapper_with_a_Button": [69,[5]],
		"/Examples/External_Components/An_Icon_Component": [70,[5]],
		"/Examples/External_Components/Replacing_a_Part_List": [71,[5]],
		"/Examples/External_Components/The_CourseSchedule_DSL": [72,[5]],
		"/Examples/Generic_Types": [73,[5]],
		"/Examples/Generic_Types/The_TyperExample_DSL": [74,[5]],
		"/Examples/Generic_Types/The_Typer_Definition": [75,[5]],
		"/Examples/Overview": [76,[5]],
		"/LionWeb": [~77,[6]],
		"/LionWeb/Overview": [78,[6]],
		"/Tutorial": [~79,[7]],
		"/Tutorial/Conclusion": [80,[7]],
		"/Tutorial/Creating_your_Metamodel": [81,[7]],
		"/Tutorial/Expressions_in_Freon": [82,[7]],
		"/Tutorial/How_to_Handle_Typing": [83,[7]],
		"/Tutorial/In_Need_of_Scoping": [84,[7]],
		"/Tutorial/Making_an_Editor": [85,[7]],
		"/Tutorial/More_Fun_with_Projections": [86,[7]],
		"/Tutorial/More_Scoping": [87,[7]],
		"/Tutorial/Overview": [88,[7]],
		"/Tutorial/Projections_for_Expressions": [89,[7]],
		"/Tutorial/Validating_the_model": [90,[7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';